// extracted by mini-css-extract-plugin
export var root = "V_x6";
export var wrapper = "V_r2";
export var image = "V_x7 d_w d_y d_W";
export var imageWithHeight = "V_x8";
export var crop = "V_x9";
export var round = "V_yb";
export var fixedHeight = "V_yc";